import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 获取店铺列表
export function findShop(params) {
  return axios.request({
    url: urlObj.crm + 'crm/mywss/tenants',
    method: 'get',
    params
  })
}

// 设置默认店铺
export function getDefault(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/employee/tenants/perferred',
    method: 'get',
    params
  })
}

// 获取仓库库存
export function getcurtenant(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/store/curtenant',
    method: 'get',
    params
  })
}

// 编辑仓库
export function editcurtenant(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/store/curtenant',
    method: 'post',
    data
  })
}

// 获取仓库市区
export function geinventoryt(params) {
  return axios.request({
    url: urlObj.crm + 'crm/resarea/gateway/city/inventory',
    method: 'get',
    params
  })
}